var _style, _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _path11, _path12, _polyline, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect, _rect2, _rect3, _rect4, _path20, _g3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect5, _rect6, _polyline2, _polygon, _g4, _g5, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g6, _g7, _rect7, _path35, _g8, _path36, _defs, _rect8, _rect9, _g9, _path37, _path38, _g10, _path39, _path40, _defs2, _path41, _g11, _path42, _path43, _g12, _path44, _path45, _g13, _path46, _path47, _path48, _g14, _circle2, _path49, _path50, _text, _path51, _path52, _path53, _line, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramista(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 1334",
    style: {
      enableBackground: "new 0 0 2000 1334"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#B9E0ED;}\n\t.st2{fill:#E5E5E5;}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:#140B4C;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#E1E9F3;}\n\t.st7{fill:#4FA2CA;}\n\t.st8{fill:url(#SVGID_3_);}\n\t.st9{fill:url(#SVGID_4_);}\n\t.st10{fill:#FFFFFF;stroke:#070606;stroke-miterlimit:10;}\n\t.st11{fill:url(#SVGID_5_);}\n\t.st12{fill:url(#SVGID_6_);}\n\t.st13{fill:#CDC9C1;}\n\t.st14{fill:url(#SVGID_7_);}\n\t.st15{fill:#D5E8F2;}\n\t.st16{fill:url(#SVGID_8_);}\n\t.st17{fill:url(#SVGID_9_);}\n\t.st18{fill:url(#SVGID_10_);}\n\t.st19{fill:url(#SVGID_11_);}\n\t.st20{fill:url(#SVGID_12_);}\n\t.st21{fill:url(#SVGID_13_);}\n\t.st22{fill:url(#SVGID_14_);}\n\t.st23{fill:url(#SVGID_15_);}\n\t.st24{fill:url(#SVGID_16_);}\n\t.st25{fill:#0D156A;}\n\t.st26{fill:#5670B2;}\n\t.st27{fill:#DB013F;}\n\t.st28{fill:#F7426E;}\n\t.st29{fill:#9096BF;}\n\t.st30{fill:#6B749C;}\n\t.st31{fill:url(#SVGID_17_);}\n\t.st32{fill:#060E35;}\n\t.st33{fill:url(#SVGID_18_);}\n\t.st34{fill:#080F42;}\n\t.st35{fill:url(#SVGID_19_);}\n\t.st36{clip-path:url(#SVGID_21_);fill:url(#SVGID_22_);}\n\t.st37{clip-path:url(#SVGID_21_);fill:#FFFFFF;}\n\t.st38{clip-path:url(#SVGID_21_);}\n\t.st39{fill:none;}\n\t.st40{fill:url(#SVGID_23_);}\n\t.st41{fill:url(#SVGID_24_);}\n\t.st42{fill:#CCCCCC;}\n\t.st43{clip-path:url(#SVGID_26_);fill:url(#SVGID_27_);}\n\t.st44{fill:url(#SVGID_28_);}\n\t.st45{fill:url(#SVGID_29_);}\n\t.st46{fill:url(#SVGID_30_);}\n\t.st47{fill:#D0D8E2;}\n\t.st48{fill:url(#SVGID_31_);}\n\t.st49{fill:url(#SVGID_32_);}\n\t.st50{fill:url(#SVGID_33_);}\n\t.st51{font-family:'ArialRoundedMTBold';}\n\t.st52{font-size:43.8402px;}\n\t.st53{fill:url(#SVGID_34_);}\n\t.st54{fill:url(#SVGID_35_);}\n\t.st55{fill:url(#SVGID_36_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1448.1161,
    y1: 462.1469,
    x2: 1889.0089,
    y2: 462.1469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A7AB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1668.6,
    cy: 462.1,
    r: 220.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.1,381.7h36c5.1,0,9.4,1.8,13.1,5.5c3.7,3.7,5.5,8.1,5.5,13.1v66.4c0,5.1-1.8,9.5-5.5,13.1 c-3.7,3.7-8.1,5.5-13.1,5.5h-51.2l-11.1,71.9H550c5.1,0,9.4,1.8,13.1,5.5c3.7,3.7,5.5,8.1,5.5,13.1v66.4c0,5.1-1.8,9.5-5.5,13.1 c-3.7,3.7-8.1,5.5-13.1,5.5h-59.5l-9,58.8c-0.9,4.1-2.9,7.6-5.9,10.4c-3,2.8-6.8,4.1-11.4,4.1h-72.6c-4.1,0-7.7-1.5-10.7-4.5 c-3-3-4.5-6.6-4.5-10.7v-1.4l8.3-56.7h-51.2l-9,58.8c-0.9,4.1-2.9,7.6-5.9,10.4c-3,2.8-6.8,4.1-11.4,4.1h-72.6 c-4.1,0-7.7-1.5-10.7-4.5c-3-3-4.5-6.6-4.5-10.7v-1.4l8.3-56.7h-35.3c-5.1,0-9.5-1.8-13.1-5.5c-3.7-3.7-5.5-8.1-5.5-13.1V576 c0-5.1,1.8-9.4,5.5-13.1c3.7-3.7,8.1-5.5,13.1-5.5h51.2l10.4-71.9h-43.6c-5.1,0-9.5-1.8-13.1-5.5c-3.7-3.7-5.5-8.1-5.5-13.1v-66.4 c0-5.1,1.8-9.4,5.5-13.1c3.7-3.7,8.1-5.5,13.1-5.5H270l9-58.8c0.9-3.7,2.8-7,5.5-10c2.8-3,6.5-4.5,11.1-4.5h73.3 c4.2,0,7.7,1.5,10.7,4.5c3,3,4.5,6.6,4.5,10.7v2.1l-9,56H427l9-58.8c0.9-3.7,2.8-7,5.5-10c2.8-3,6.4-4.5,11.1-4.5h73.3 c4.1,0,7.7,1.5,10.7,4.5c3,3,4.5,6.6,4.5,10.7v2.1L532.1,381.7z M348.8,557.3h51.9l10.4-71.9h-51.2L348.8,557.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M706.8,832c0,0,81.9,50.3,135.6,137.5c53.7,87.2,266.5,184.1,435.5,86.8c16.1-9.3,30.2-17.6,42.7-25 c6.3-3.7,12.1-7.2,17.6-10.5c40.3-26.7,84.7-52.6,134.2-50.7c5.5,0.2,11.1,0.8,16.7,1.7c6.2,1,12.4,1.9,18.7,2.6 c6.3,0.8,12.6,1.6,19,2.5c18.3,5.7,37.2,8,55.6,6.9c6.1-0.4,12.2-1.1,18.2-2.2c13.5-2.4,26.9-5.6,39.7-10.3 c4.3-1.6,8.4-3.4,12.6-5.3c4.9-2.2,9.5-4.8,14.1-7.6c4.5-2.8,8.9-5.9,13-9.3c4.6-3.9,9.1-8.1,13.4-12.4c4.3-4.3,8.5-8.8,12.6-13.4 c14.1-13,26.3-27.6,36.2-43.5c3.3-5.3,6.3-10.7,9.2-16.4c2.4-4.6,4.9-9.3,7.3-14c2.4-4.7,4.7-9.5,6.9-14.3 c3.1-5.8,5.7-11.7,7.9-17.6c2.1-6,3.8-12,5.1-18.1c11.4-63.7-4.1-135.6-50.7-181.6c-4.1-4.3-8.4-8.4-12.9-12.3 c-31.1-27.2-69.4-44.8-110.9-52.1c-5.7-1.8-11.3-3.8-16.8-5.9c-44.2-17.1-84.9-45.5-124-70.4c-3.4-2.6-6.8-5.1-10.1-7.6 c-13.4-10.1-26.7-19.8-40.9-29.8c-4.7-3.4-8.9-7.2-12.4-11.9c-3.6-4.3-6.6-9-9-14.2c-2.1-4.5-3.9-9.1-5.7-13.7 c-1.8-4.6-3.5-9.1-5.3-13.7c-4.1-12.7-9.9-24.8-17.2-35.8c-3.7-5.5-7.8-10.7-12.2-15.5c-3-3-6.1-5.8-9.3-8.5 c-4.7-3.6-9.3-7.3-14-10.8c-52-31.6-114.5-49.4-175.2-45.8c-6.2,0.7-12.3,1.5-18.4,2.4c-12.2,1.9-24.4,4.5-36.4,7.8 c-6.4,1.4-12.7,3.2-18.8,5.3c-42.9,15.1-78.2,50.5-91.1,96.1c-1.1,5.6-1.6,11.5-2,17.3c-0.2,3.9-0.4,7.8-0.7,11.6 c-5.6,31.9-29.6,55.3-54.7,74.8c-5,3.9-10.1,7.7-15.1,11.3c-2.7,2.9-6.2,4.3-9.6,5.8c-48.9,21.2-102.1,25.6-141.8,62.9 c-23.8,22.1-34.7,52.9-48.1,81.5c-1.6,3.7-3.1,7.5-4.5,11.2c-23.1,60.3-27.8,125-2.1,161.5"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1147,208.5l-592.5-6.9c-42.1-0.5-48,33.7-48.5,75.8l-0.2,19.2l-4.8,409.8c-0.5,42.1,36.3,76.6,78.4,77.1 l560.8,6.6c42.1,0.5,76.7-33.2,77.2-75.3l4.8-409.8l0.2-19.2C1222.9,243.7,1214.3,208.5,1147,208.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.2264,
    y1: 26.1174,
    x2: 1207.6586,
    y2: 26.1174,
    gradientTransform: "matrix(0.9999 1.170000e-02 -1.170000e-02 0.9999 -8.9388 195.2465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A7AB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1198,264.1c0.5-42.1-8.1-77.2-75.4-77.2l-592.5-6.9c-42.1-0.5-48,33.7-48.5,75.8l-0.2,19.2l716.4,8.4 L1198,264.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M481.4,274.9l-4.8,409.8c-0.5,42.1,36.3,76.6,78.4,77.1l560.8,6.6c42.1,0.5,76.7-33.2,77.2-75.3l4.8-409.8 L481.4,274.9z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1088.6,234.4c-0.1,10.1-8.4,18.2-18.6,18.1c-10.1-0.1-18.2-8.4-18.1-18.6c0.1-10.1,8.4-18.2,18.6-18.1 C1080.6,215.9,1088.7,224.3,1088.6,234.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1149.7,235.1c-0.1,10.1-8.4,18.2-18.6,18.1c-10.1-0.1-18.2-8.4-18.1-18.6c0.1-10.1,8.4-18.2,18.6-18.1 C1141.7,216.7,1149.8,225,1149.7,235.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M792,227c0,4.3-3.5,7.7-7.7,7.7H548.4c-4.3,0-7.7-3.5-7.7-7.7l0,0c0-4.3,3.5-7.7,7.7-7.7h235.9 C788.6,219.3,792,222.7,792,227L792,227z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1361.8,455.6c-0.8-2.7-1.6-5.3-2.3-7.7c-0.7-2.4-1.5-4.6-2.2-6.7c-0.7-2.1-1.3-4-1.9-5.7 c-0.8-2.2-1.5-4.1-2.1-5.7c-5.3-2.3-44.4-21.3-37.5-71.9c0,0,53.9,14.5,38.2,71.6c0.8,1.5,1.8,3.2,2.9,5.3c1.7,3.2,3.6,7.2,5.7,11.9 c1,2.3,2.1,4.8,3.2,7.5c1.2,2.6,1.8,5.6,2.8,8.5c0.7,2.3,1.5,4.8,2.2,7.3c0.8-2.7,1.8-6.1,2.9-9.7c0.5-1.8,1-3.5,1.5-5.2 c0.2-0.6,0.4-1.2,0.6-1.8c-28.4-55.7,10.5-80,10.5-80c22.3,61.7-0.5,76.5-8.1,79.5c-0.3,0.9-0.6,1.9-1,2.9c-0.5,1.6-1,3.4-1.5,5.1 c-1,3.5-2.1,7-2.9,9.7c-0.1,0.3-0.1,0.7-0.3,0.9c-0.2,0.3-0.3,0.5-0.5,0.8c-0.2,0.3-0.3,0.4-0.4,0.7c0.8,3,1.6,6,2.4,9.2 c0.4,1.7,0.9,3.5,1.4,5.3c0.4,1.8,0.8,3.6,1.2,5.5c0.8,3.7,1.6,7.5,2.4,11.3c0.7,3.9,1.4,7.7,1.9,11.7c0.3,1.9,0.5,3.8,0.8,5.7 c0.1-0.6,0.1-1.1,0.3-1.7c0.2-1,0.4-2,0.6-3.1c0.4-2.1,0.7-4.1,1.1-6.1c0.5-1.9,0.9-3.7,1.2-5.2c0.1-0.4,0.1-0.8,0.3-1.1 c0.2-0.3,0.3-0.6,0.5-0.9c0.1-0.3,0.3-0.5,0.4-0.7c-2.2-9.5-8.1-48.1,32.7-72.9c0,0,22.6,50.9-31.5,74.7c0,0.1,0,0.2,0,0.3 c0,0.4-0.2,0.7-0.3,1.1c-0.4,1.5-0.8,3.3-1.2,5.1c-0.3,1.9-0.7,3.9-1.1,6c-0.2,1-0.4,2-0.6,3c-0.2,1-0.3,2-0.4,2.9 c-0.2,1.9-0.4,3.7-0.5,5.3c-0.1,0.4,0,0.8-0.1,1.1c-0.1,0.2-0.1,0.4-0.2,0.6c1,7.4,1.9,14.8,3.4,22.1c0.7,4.1,1.7,8,2.6,12 c0.5,2,1.1,3.9,1.7,5.9c0.6,1.9,1.1,3.9,1.8,5.8c0.2,0.4,0.3,0.8,0.5,1.3c0-0.3,0.1-0.6,0.1-0.9c0.1-1.4,0.4-2.8,0.7-4.2 c0.2-1.5,0.7-2.9,1.1-4.5c0.5-1.5,1-3,1.6-4.5c0.6-1.3,1.2-2.7,1.9-4c-0.3,0-0.6,0-0.9,0.1c0,0-2-48.4,47.6-58.1 c0,0,7.8,53.3-44.1,57.8c-0.2,0.3-0.4,0.6-0.5,0.9c-0.8,1.3-1.3,2.7-2,4.1c-0.6,1.4-1,2.9-1.5,4.3c-0.3,1.5-0.8,2.9-1,4.3 c-0.3,1.4-0.5,2.8-0.7,4.1c-0.2,1.3-0.3,2.5-0.3,3.7c-0.1,0.6,0,1.1-0.1,1.6c0,0.1,0,0.1,0,0.2c0.6,1.7,1.3,3.4,2,5 c0.8,1.8,1.5,3.6,2.3,5.4c0.8,1.8,1.8,3.5,2.6,5.2c0.9,1.7,1.7,3.4,2.6,5.1c0.9,1.6,1.9,3.3,2.8,4.9c1.9,3.2,3.6,6.4,5.6,9.3 c2,3,3.8,5.8,5.7,8.6c0.5,0.6,0.9,1.3,1.4,1.9c-0.1-0.7-0.2-1.5-0.2-2.3c-0.2-3.4,0.2-6.7,0.8-9.2c0.1-0.3,0.1-0.6,0.2-0.9 c0.2-0.3,0.3-0.5,0.4-0.7c0.2-0.3,0.4-0.5,0.5-0.8c-1.4-4.9-10.3-41.5,26.8-60.1c0,0,19.9,44.8-25.7,60.4c0,0.3,0,0.6,0,1 c0,0.3,0,0.5,0,0.8c0,0.3-0.2,0.5-0.2,0.8c-0.5,2.3-1,5.4-0.8,8.6c0.1,1.6,0.3,3.1,0.6,4.5c0.1,0.7,0.4,1.4,0.5,2 c0,0.1,0.1,0.2,0.1,0.3c0.4,0.5,0.7,1,1.1,1.5c0.9,1.2,1.8,2.5,2.7,3.7c0.9,1.2,1.8,2.3,2.6,3.5c1.6,2.3,3.1,4.5,4.6,6.6 c2.8,4.2,5.5,7.7,7.7,10.6c4.4,5.8,6.8,9.2,6.8,9.2s-2.9-2.9-8-8.2c-2.5-2.6-5.7-5.8-9-9.6c-1.2-1.3-2.4-2.7-3.7-4.1 c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6-0.1-0.9-0.1c-0.3,0-0.6-0.2-0.9-0.3c-0.6-0.2-1.2-0.5-1.9-0.7c-0.7-0.2-1.5-0.3-2.3-0.5 c-0.8-0.2-1.6-0.4-2.4-0.6c-0.8-0.1-1.7-0.2-2.5-0.3c-0.8-0.1-1.7-0.2-2.5-0.2c-0.8,0-1.7,0-2.5,0c-0.8,0-1.6,0.1-2.3,0.2 c-0.7,0.1-1.4,0.1-2,0.2c-0.3,0-0.6,0.2-0.9,0.2c-0.2,0-0.3,0-0.4,0c-7.1,5.1-41.2,26.4-80.2-2.7c0,0,38.3-39.7,80.5,0.5 c0.2,0,0.5-0.1,0.7-0.1c0.7-0.1,1.4-0.2,2.2-0.3c0.8-0.1,1.6-0.2,2.4-0.2c0.8,0,1.7,0,2.6,0c0.9-0.1,1.8,0.1,2.7,0.2 c0.9,0.1,1.8,0.2,2.7,0.3c0.9,0.1,1.7,0.4,2.6,0.6c0.8,0.2,1.6,0.4,2.4,0.6c0.4,0.1,0.7,0.2,1,0.3c-1.6-1.9-3-4.1-4.6-6.2 c-1.8-2.5-3.8-5.2-5.7-7.9c-1.8-2.8-3.8-5.8-5.7-8.8c-2-3-3.8-6.2-5.7-9.5c-0.9-1.6-1.9-3.3-2.9-5c-0.5-0.9-0.9-1.8-1.4-2.7 c-0.1,0-0.2,0-0.4,0c-0.2,0-0.4-0.2-0.6-0.3c-1.6-0.7-3.8-1.7-6-2.7c-2.2-1-4.4-2-6-2.7c-0.1-0.1-0.3-0.1-0.4-0.2 c-10.7,2.4-47.9,7.3-72.3-32.4c0,0,51-23.1,75.1,31.2c1.4,0.6,2.9,1.3,4.5,2c1.6,0.7,3.2,1.4,4.6,2.1c-0.8-1.7-1.7-3.3-2.5-5 c-0.8-1.8-1.6-3.7-2.4-5.5c-1.7-3.7-3-7.6-4.4-11.5c-0.7-1.9-1.3-3.9-1.9-5.9c-0.6-2-1.2-4-1.7-6c-0.7-3-1.4-6.1-2-9.1 c-0.2-0.3-0.3-0.6-0.5-0.9c-0.9-1.7-1.8-3.8-3.1-5.9c-1.2-2.1-2.5-4.4-3.9-6.6c-2.7-4.5-5.6-8.9-7.8-12.2c-0.3-0.4-0.6-0.8-0.8-1.2 c-0.1-0.2-0.2-0.4-0.3-0.7c-6-0.6-50.7-6.7-51.7-58.2c0,0,63.3,12.1,52.7,56.6c0,0,0.1,0.1,0.1,0.1c0.3,0.3,0.6,0.6,0.9,0.9 c0.3,0.3,0.5,0.8,0.8,1.2c2.2,3.3,5.1,7.7,7.9,12.2c1.4,2.2,2.7,4.6,3.9,6.7c0.1,0.2,0.2,0.3,0.2,0.5c-1.2-6.8-2-13.6-2.9-20.3 c-0.5-4.1-1.1-8-1.6-12c-0.6-3.9-1.3-7.9-1.9-11.7c-0.8-3.8-1.6-7.5-2.3-11.1c-0.4-1.8-0.8-3.6-1.1-5.4c-0.4-1.8-0.9-3.5-1.3-5.2 c-0.8-3.1-1.6-6-2.4-9c-0.4-0.7-0.8-1.5-1.4-2.2c-0.6-0.9-1.3-1.9-2-2.7c-0.7-0.9-1.4-1.8-2.2-2.6c-0.7-0.8-1.6-1.6-2.3-2.3 c-1.6-1.4-3.1-2.7-4.5-3.7c-0.3-0.3-0.7-0.4-1-0.7c-0.3-0.3-0.6-0.6-0.8-0.8c0,0,0,0,0-0.1c-9,0.6-38.9-0.3-44.2-34.9 c0,0,40.3-5.4,46.7,34.3c0.2,0.2,0.4,0.3,0.6,0.4c1.5,1,3.1,2.3,4.8,3.8c0.8,0.8,1.7,1.6,2.4,2.4c0.7,0.8,1.4,1.6,2,2.4 c-0.4-1.2-0.8-2.4-1.1-3.6C1363.6,461.1,1362.6,458.3,1361.8,455.6z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1717.3,944.6c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1714.9,939.2,1717.3,941.6,1717.3,944.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1747.6,944.6c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1745.2,939.2,1747.6,941.6,1747.6,944.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1777.9,944.6c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1775.5,939.2,1777.9,941.6,1777.9,944.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1808.1,944.6c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1805.8,939.2,1808.1,941.6,1808.1,944.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1838.4,944.6c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1836,939.2,1838.4,941.6,1838.4,944.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1868.7,944.6c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3S1868.7,941.6,1868.7,944.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1717.3,977.7c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1714.9,972.3,1717.3,974.7,1717.3,977.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1747.6,977.7c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1745.2,972.3,1747.6,974.7,1747.6,977.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1777.9,977.7c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1775.5,972.3,1777.9,974.7,1777.9,977.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1808.1,977.7c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1805.8,972.3,1808.1,974.7,1808.1,977.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1838.4,977.7c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1836,972.3,1838.4,974.7,1838.4,977.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1868.7,977.7c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3S1868.7,974.7,1868.7,977.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1717.3,1010.8c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1714.9,1005.5,1717.3,1007.8,1717.3,1010.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1747.6,1010.8c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1745.2,1005.5,1747.6,1007.8,1747.6,1010.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1777.9,1010.8c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1775.5,1005.5,1777.9,1007.8,1777.9,1010.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1808.1,1010.8c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1805.8,1005.5,1808.1,1007.8,1808.1,1010.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1838.4,1010.8c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1836,1005.5,1838.4,1007.8,1838.4,1010.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1868.7,1010.8c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3S1868.7,1007.8,1868.7,1010.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1717.3,1043.9c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1714.9,1038.6,1717.3,1041,1717.3,1043.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1747.6,1043.9c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1745.2,1038.6,1747.6,1041,1747.6,1043.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1777.9,1043.9c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1775.5,1038.6,1777.9,1041,1777.9,1043.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1808.1,1043.9c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1805.8,1038.6,1808.1,1041,1808.1,1043.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1838.4,1043.9c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C1836,1038.6,1838.4,1041,1838.4,1043.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1868.7,1043.9c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3S1868.7,1041,1868.7,1043.9z"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1441.8,884.9c0,7.5-3.8,13.5-8.5,13.5h-77.8c-4.7,0-8.5-6.1-8.5-13.5V656.4c0-7.5,3.8-13.5,8.5-13.5h77.8 c4.7,0,8.5,6,8.5,13.5V884.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1338.4,624.7l24.9-58.3l-28.1-23.5l-52.6-9.2c0,0-18.8,44.4,18.7,52.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1170.665,
    y1: 720.3651,
    x2: 1310.7227,
    y2: 720.3651
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEB01F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3A40"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1281.8,654c-11,12.1-15.5,35.5-25.9,55.9c-14.5,28.3-60.8,65.4-85.2,71.1l9,16.4c0,0,72.4-7.6,99.5-44.2 c20.7-27.8,41.1-97.9,26.8-108.9C1302.6,641.7,1291.3,643.4,1281.8,654z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1128.8278,
    y1: 792.7865,
    x2: 1186.8448,
    y2: 792.7865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    style: {
      stopColor: "#FDDC70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4036,
    style: {
      stopColor: "#FDC96B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6217,
    style: {
      stopColor: "#FC995C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9277,
    style: {
      stopColor: "#FB4C45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3A40"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1170.7,781.1l-27.2,5.3c0,0-8.4,1.7-9.4,3.8c-1,2.1-5.2,14.3-5.2,14.3l58-1.2"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "1171.9,795.1 1168.3,801 1156.5,802.2  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1273.8857,
    y1: 691.998,
    x2: 1357.064,
    y2: 757.1977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEB01F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3A40"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1403.5,807.1c0,0-32.8-103.9-23.1-144.8c0,0-3.2-18.8-33.4-19.4c0,0-7.2-0.2-10-0.8 c-7.4-1.6-37.8,1.4-37.8,1.4s-15.4,17.4-22.8,41.2c-13.1,42.4-6.8,122.6-6.8,122.6l25.5-0.1l41.5-0.2c0.1,1.1,0.1,1.6,0.1,1.6 L1403.5,807.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1833.0719,
    y1: 630.436,
    x2: 1796.5968,
    y2: 628.6907,
    gradientTransform: "matrix(-1 0 0 1 3145.2617 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    style: {
      stopColor: "#FDDC70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4036,
    style: {
      stopColor: "#FDC96B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6217,
    style: {
      stopColor: "#FC995C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9277,
    style: {
      stopColor: "#FB4C45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3A40"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1334.7,602.8l6.7,39.9c0,0-18.2,15.7-26.8,13.9c-7.1-1.5,1.9-40,1.9-40L1334.7,602.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1313.5,634.1c0,0,20,2,23.1-25.2l3.4-2.8l-14.2-0.7l-10.9,15.6L1313.5,634.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1860.2058,
    y1: 597.955,
    x2: 1779.3633,
    y2: 601.4114,
    gradientTransform: "matrix(-1 0 0 1 3145.2617 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FDDC70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5222,
    style: {
      stopColor: "#FDC96B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    style: {
      stopColor: "#FC995C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9421,
    style: {
      stopColor: "#FB4C45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3A40"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1299.3,579.6c0,0-8.2,44.9,10.4,49.3c18.6,4.5,24.6-18.6,24.6-18.6s15.3,1.9,13.4-17.9 c-1.2-12.1-13.4-8.2-13.4-8.2l-0.6-12.8c0,0-11.8-6.1-19.5,2C1306.4,581.5,1299.3,579.6,1299.3,579.6z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1324.3,609.9l-20.4,0.2c0,0,2.2,9.2,10.1,9.2"
  })), /*#__PURE__*/React.createElement("g", null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1380.3,398.6c27.9-27.9,27.9-73,0-100.9c-27.9-27.9-73-27.9-100.9,0c-27.8,27.9-27.8,73,0,100.9 C1307.3,426.5,1352.4,426.5,1380.3,398.6z M1289.4,307.7c22.4-22.4,58.6-22.4,81,0c22.4,22.4,22.4,58.6,0,81 c-22.4,22.4-58.6,22.4-81,0C1267,366.3,1267,330.1,1289.4,307.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1375.3,342.2c0,31.6-25.6,57.3-57.3,57.3c-31.6,0-57.3-25.6-57.3-57.3c0-31.6,25.6-57.3,57.3-57.3 C1349.6,285,1375.3,310.6,1375.3,342.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1316.0065,
    y1: 290.8784,
    x2: 1320.0277,
    y2: 290.8784
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1316,
    y: 279.8,
    className: "st16",
    width: 4,
    height: 22.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1316.0065,
    y1: 393.574,
    x2: 1320.0277,
    y2: 393.574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1316,
    y: 382.5,
    className: "st17",
    width: 4,
    height: 22.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1358.2499,
    y1: 342.2256,
    x2: 1380.4835,
    y2: 342.2256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1358.2,
    y: 340.2,
    className: "st18",
    width: 22.2,
    height: 4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1255.5519,
    y1: 342.2256,
    x2: 1277.7886,
    y2: 342.2256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1255.6,
    y: 340.2,
    className: "st19",
    width: 22.2,
    height: 4
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1318.0171,
    y1: 413.5411,
    x2: 1318.0171,
    y2: 270.9127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A7AB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1318,270.9c-39.4,0-71.3,31.9-71.3,71.3c0,39.4,31.9,71.3,71.3,71.3c39.4,0,71.3-31.9,71.3-71.3 C1389.3,302.8,1357.4,270.9,1318,270.9z M1318,399.5c-31.6,0-57.3-25.6-57.3-57.3c0-31.6,25.6-57.3,57.3-57.3 c31.6,0,57.3,25.6,57.3,57.3C1375.3,373.9,1349.6,399.5,1318,399.5z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1329.9,361.3 1316.3,342.8 1316.3,312.7 1319.8,312.7 1319.8,341.6 1332.7,359.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1302.1687,
    y1: 352.1179,
    x2: 1320.028,
    y2: 352.1179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1047,
    style: {
      stopColor: "#FC6F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9543,
    style: {
      stopColor: "#F7426E"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1303.5,363.3c-0.3,0-0.6-0.1-0.8-0.3c-0.6-0.4-0.7-1.3-0.2-1.8l15.2-19.8c0.4-0.6,1.3-0.7,1.8-0.2 c0.6,0.4,0.7,1.3,0.2,1.8l-15.2,19.8C1304.3,363.2,1303.9,363.3,1303.5,363.3z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1246.8834,
    y1: 791.061,
    x2: 1321.9124,
    y2: 791.061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    style: {
      stopColor: "#FDDC70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4036,
    style: {
      stopColor: "#FDC96B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6217,
    style: {
      stopColor: "#FC995C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9277,
    style: {
      stopColor: "#FB4C45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3A40"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1308.3,778.9l-26.6-1.4c0,0-29.4,12.6-31.2,14c-1.8,1.4-3.2,10.8-3.2,10.8s-2.2,0.4,3.6,0.7 c5.7,0.4,26.2,1.8,26.2,1.8s22.6-6.8,26.2-7.2c3.6-0.4,18.7,0,18.7,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1306.3647,
    y1: 726.3186,
    x2: 1412.1138,
    y2: 726.3186
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEB01F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3A40"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1369.3,648.6c0,0,30.6,4.8,33.7,38.8c2.7,29.3,14.1,106.9,6.6,113.4c-7.5,6.5-103.2,1.4-103.2,1.4v-26.9 l64.9-1.1l-8.8-87.2C1362.5,687,1342.3,650.8,1369.3,648.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1590,809.2c0,2-1.7,3.1-3.7,3.1h-511.1c-2,0-3.6-1.1-3.6-3.1v-1.8c0-2,1.6-4,3.6-4h511.1c2,0,3.7,2,3.7,4 V809.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1212.1,756c0.6,2.9-1.3,5.3-4.2,5.3h-255c-2.9,0-5.7-2.4-6.3-5.3l-28.4-147.4c-0.6-2.9,1.3-5.5,4.2-5.5h255 c2.9,0,5.7,2.6,6.3,5.5L1212.1,756z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -3314.5498,
    y1: 682.7116,
    x2: -3015.3806,
    y2: 682.7116,
    gradientTransform: "matrix(1 0 0 1 4211.4062 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A7AB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1195.9,756.4c0.6,2.9-1.4,5.9-4.3,5.9H932.2c-2.9,0-5.8-2.9-6.4-5.9L897,608.3c-0.6-2.9,1.4-5.1,4.3-5.1 h259.4c3,0,5.8,2.1,6.4,5.1L1195.9,756.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1092.4,733.7c0.2,1-0.4,1.8-1.4,1.8h-85.2c-1,0-1.9-0.9-2.1-1.8l-9.6-49.3c-0.2-1,0.4-1.8,1.4-1.8h85.2 c1,0,1.9,0.8,2.1,1.8L1092.4,733.7z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 983,
    y: 792.7,
    className: "st26",
    width: 297.4,
    height: 12.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 982.3,
    y: 801,
    className: "st25",
    width: 297.4,
    height: 12.5
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "1046.1,811.7 1068.5,729.2 1053.9,729.2 1031.4,811.8  "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "1019,733.7 997.6,812.2 1037.1,812.2 1059.6,729.5 1020.4,728.9  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M826.3,344c0,5-4,9-9,9H687.3c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h129.9C822.2,335,826.3,339,826.3,344L826.3,344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1066.9,344.8c0,5-4,9-9,9H928c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h129.9C1062.9,335.8,1066.9,339.8,1066.9,344.8 L1066.9,344.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M903.3,344.6c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C899.2,335.6,903.3,339.6,903.3,344.6 L903.3,344.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M761.3,377.5c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C757.3,368.5,761.3,372.5,761.3,377.5 L761.3,377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M918.5,412c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C914.5,403,918.5,407,918.5,412L918.5,412z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M927.3,378.3c0,5-4,9-9,9H788.4c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h129.9C923.3,369.3,927.3,373.3,927.3,378.3 L927.3,378.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M849.5,477c0,5-4,9-9,9h-69.8c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h69.8C845.5,467.9,849.5,472,849.5,477L849.5,477z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M1087.8,380.7c0,5-4,9-9,9H948.8c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h129.9C1083.7,371.7,1087.8,375.7,1087.8,380.7 L1087.8,380.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M838.9,410.8c0,5-4,9-9,9H699.9c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h129.9C834.9,401.7,838.9,405.8,838.9,410.8 L838.9,410.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M909.5,441.3c0,5-4,9-9,9H770.5c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h129.9C905.5,432.2,909.5,436.3,909.5,441.3 L909.5,441.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M862,543.5c0,5-4,9-9,9h-81.8c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h81.8C857.9,534.5,862,538.5,862,543.5L862,543.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M910.7,509.2c0,5-4,9-9,9H771.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h129.9C906.7,500.2,910.7,504.3,910.7,509.2 L910.7,509.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1080.4,413.2c0,5-4,9-9,9H941.4c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h129.9C1076.3,404.2,1080.4,408.2,1080.4,413.2 L1080.4,413.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657,336.6c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9H648C653,327.5,657,331.6,657,336.6L657,336.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M586.3,337.3c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C582,327.6,586.3,331.9,586.3,337.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657,370.7c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9H648C653,361.7,657,365.8,657,370.7L657,370.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M586.3,371.4c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C582,361.8,586.3,366.1,586.3,371.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657,404.9c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9H648C653,395.9,657,399.9,657,404.9L657,404.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M586.3,405.6c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C582,396,586.3,400.3,586.3,405.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M741.2,439.1c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C737.2,430.1,741.2,434.1,741.2,439.1 L741.2,439.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M670.6,439.8c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C666.2,430.1,670.6,434.5,670.6,439.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M741.2,473.3c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C737.2,464.2,741.2,468.3,741.2,473.3 L741.2,473.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M670.6,473.9c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C666.2,464.3,670.6,468.6,670.6,473.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M948.2,476.9c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C944.2,467.8,948.2,471.9,948.2,476.9 L948.2,476.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M877.5,477.6c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C873.2,467.9,877.5,472.2,877.5,477.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1010.2,507c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C1006.1,497.9,1010.2,502,1010.2,507 L1010.2,507z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M939.5,507.6c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C935.2,498,939.5,502.3,939.5,507.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M761.7,612.9c0,5-4,9-9,9h-69.8c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h69.8C757.7,603.9,761.7,607.9,761.7,612.9 L761.7,612.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M821.7,577.2c0,5-4,9-9,9H682.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h129.9C817.6,568.2,821.7,572.2,821.7,577.2 L821.7,577.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M774.1,679.5c0,5-4,9-9,9h-81.8c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h81.8C770.1,670.5,774.1,674.5,774.1,679.5 L774.1,679.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M822.9,645.2c0,5-4,9-9,9H683.9c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h129.9C818.8,636.2,822.9,640.2,822.9,645.2 L822.9,645.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M860.4,612.8c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C856.3,603.8,860.4,607.9,860.4,612.8 L860.4,612.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M789.7,613.5c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C785.4,603.9,789.7,608.2,789.7,613.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M922.3,642.9c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C918.3,633.9,922.3,637.9,922.3,642.9 L922.3,642.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M851.7,643.6c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C847.3,634,851.7,638.3,851.7,643.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M741.2,507.4c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C737.2,498.4,741.2,502.5,741.2,507.4 L741.2,507.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M670.6,508.1c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C666.2,498.5,670.6,502.8,670.6,508.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M741.2,541.6c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9h45.7C737.2,532.6,741.2,536.6,741.2,541.6 L741.2,541.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M670.6,542.3c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C666.2,532.7,670.6,537,670.6,542.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657,575.8c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9H648C653,566.8,657,570.8,657,575.8L657,575.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M586.3,576.5c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C582,566.8,586.3,571.2,586.3,576.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657,610c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9H648C653,600.9,657,605,657,610L657,610z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 576.7,
    cy: 610.6,
    r: 9.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657,644.1c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9H648C653,635.1,657,639.1,657,644.1L657,644.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 576.7,
    cy: 644.8,
    r: 9.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657,678.3c0,5-4,9-9,9h-45.7c-5,0-9-4-9-9l0,0c0-5,4-9,9-9H648C653,669.3,657,673.3,657,678.3L657,678.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M586.3,679c0,5.3-4.3,9.6-9.6,9.6c-5.3,0-9.6-4.3-9.6-9.6c0-5.3,4.3-9.6,9.6-9.6 C582,669.4,586.3,673.7,586.3,679z"
  })))), /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M830.2,1080.9c2.9,0,5.5-1.6,6.5-4.1l100.8-256.6c1.3-3.2-0.6-6.7-4.2-7.8c-3.6-1.1-7.6,0.6-8.8,3.8 l-100.8,256.6c-1.3,3.2,0.6,6.7,4.2,7.8C828.7,1080.8,829.5,1080.9,830.2,1080.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M998.2,812c2.9,0,5.5,1.6,6.5,4.1l100.8,256.6c1.3,3.2-0.6,6.7-4.2,7.8c-3.6,1.1-7.6-0.6-8.8-3.8 L991.7,820.2c-1.3-3.2,0.6-6.7,4.2-7.8C996.7,812.1,997.5,812,998.2,812z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 907.5,
    y: 875.7,
    className: "st29",
    width: 118.6,
    height: 9.2
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1171.3,923c0,7.3,4.5,13.2,10,13.2h231.6c5.5,0,10-5.9,10-13.2v-10.5c0-7.3-4.5-13.2-10-13.2h-231.6 c-5.5,0-10,5.9-10,13.2V923z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 1938.005,
    y1: 1036.3995,
    x2: 2017.1628,
    y2: 1036.3995,
    gradientTransform: "matrix(-1 0 0 1 3088.5938 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09595919,
    style: {
      stopColor: "#FDDC70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    style: {
      stopColor: "#FDD76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#FDCA6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5163,
    style: {
      stopColor: "#FDB464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    style: {
      stopColor: "#FC965A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8263,
    style: {
      stopColor: "#FB6E4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9838,
    style: {
      stopColor: "#FA3F42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3A40"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1150.6,1014.5l-7.6,55.5h-69.8l-1.8-17.5c0,0,26.2,3.5,39.2-9.5c13-13,17.5-40.2,17.5-40.2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1328.8,820.4c0,0,16.8,78.2-7.6,84.1c-24.4,5.9-131,2.6-131,2.6h-16l-16.9,112l-39.5-2l14.3-139.5 l100.6-32.7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1042.3,1071.7c0.2-13.6,11.3-24.5,24.9-24.5c13.6,0,24.7,10.9,24.9,24.5h51v5.9h-100.9L1042.3,1071.7 L1042.3,1071.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1874.4056,
    y1: 1043.2745,
    x2: 1953.5635,
    y2: 1043.2745,
    gradientTransform: "matrix(-1 0 0 1 3088.5938 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09595919,
    style: {
      stopColor: "#FDDC70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    style: {
      stopColor: "#FDD76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#FDCA6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5163,
    style: {
      stopColor: "#FDB464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    style: {
      stopColor: "#FC965A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8263,
    style: {
      stopColor: "#FB6E4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9838,
    style: {
      stopColor: "#FA3F42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3A40"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M1214.2,1021.4l-7.6,55.5h-69.8l-1.8-17.5c0,0,26.2,3.5,39.2-9.5c13-13,17.5-40.2,17.5-40.2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M1392.4,827.2c0,0,16.8,78.2-7.6,84.1c-24.4,5.9-131,2.6-131,2.6h-16l-16.9,112l-39.5-2l-0.3-136.1l139-39.8 l-0.9-20.6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1105.9,1078.6c0.2-13.6,11.3-24.5,24.9-24.5c13.6,0,24.7,10.9,24.9,24.5h51v5.9h-100.9L1105.9,1078.6 L1105.9,1078.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1285.8,
    y: 930.7,
    className: "st30",
    width: 22.5,
    height: 85.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1291.3,
    y: 964.5,
    className: "st30",
    width: 11.4,
    height: 124.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M1219.6,1081.4c0,4,3.3,7.3,7.3,7.3h140.3c4,0,7.3-3.3,7.3-7.3l0,0c0-4-3.3-7.3-7.3-7.3h-140.3 C1222.8,1074.1,1219.6,1077.4,1219.6,1081.4L1219.6,1081.4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1319.3,1080.9c2.9,0,5.5-1.6,6.5-4.1l100.8-256.6c1.3-3.2-0.6-6.7-4.3-7.8c-3.6-1.1-7.6,0.6-8.8,3.8 l-100.8,256.6c-1.3,3.2,0.6,6.7,4.2,7.8C1317.8,1080.8,1318.5,1080.9,1319.3,1080.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1487.3,812c2.9,0,5.5,1.6,6.5,4.1l100.8,256.6c1.3,3.2-0.6,6.7-4.2,7.8c-3.6,1.1-7.6-0.6-8.8-3.8 l-100.8-256.6c-1.3-3.2,0.6-6.7,4.2-7.8C1485.8,812.1,1486.6,812,1487.3,812z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1396.6,
    y: 875.7,
    className: "st29",
    width: 118.6,
    height: 9.2
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 841.5,
    y: 812.4,
    className: "st5",
    width: 728.6,
    height: 21.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 1091.87,
    y1: 512.2999,
    x2: 1240.2822,
    y2: 512.2999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEB01F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA3A40"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M1240.3,525.9c0,16.2-13.1,29.3-29.3,29.3h-89.7c-16.2,0-29.3-13.1-29.3-29.3v-27.2 c0-16.2,13.1-29.3,29.3-29.3h89.7c16.2,0,29.3,13.1,29.3,29.3V525.9z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1132.2,512.3c1.3,0.8,2.3,1.7,3,2.6c0.7,1,1.2,2.2,1.5,3.7c0.3,1.5,0.4,3.4,0.4,5.8c0,1.8,0,3.1,0.1,3.9 c0.1,0.8,0.2,1.5,0.5,1.9c0.2,0.4,0.5,0.7,0.9,0.9c0.3,0.1,0.9,0.3,1.7,0.4c0.7,0.1,1.2,0.4,1.7,1c0.4,0.6,0.7,1.3,0.7,2.2 c0,2.2-1.3,3.2-3.9,3.2c-1.6,0-3.1-0.3-4.3-1c-1.3-0.7-2.3-1.6-3-2.9c-0.7-1.2-1.1-2.7-1.1-4.3c-0.1-2.7-0.1-4.9-0.2-6.5 c-0.1-1.6-0.1-2.7-0.2-3.2c-0.3-1.2-0.7-2.1-1.2-2.7c-0.5-0.6-1.2-1.2-2.1-1.7c-0.8-0.5-1.4-1-1.8-1.4c-0.4-0.4-0.5-1.1-0.5-2 c0-1.3,0.5-2.3,1.6-3c1.3-0.8,2.2-1.5,2.7-2c0.5-0.6,0.9-1.3,1.1-2.2c0.2-0.9,0.4-1.8,0.4-2.9c0-1,0.1-3.6,0.2-7.5 c0.1-2.5,0.8-4.4,2.3-5.9c1.5-1.5,3.5-2.2,6-2.2c2.6,0,3.9,1.1,3.9,3.2c0,1-0.2,1.7-0.7,2.3c-0.4,0.6-1,0.9-1.7,1 c-1,0.1-1.8,0.4-2.2,0.6c-0.4,0.3-0.7,0.8-0.8,1.7c-0.1,0.8-0.2,2.4-0.2,4.8c0,2.3-0.2,4.2-0.4,5.7c-0.2,1.5-0.7,2.7-1.4,3.8 C1134.5,510.5,1133.5,511.5,1132.2,512.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1165.7,527.2c-1.2,0-2.2-0.4-3-1.1c-0.9-0.7-1.3-1.7-1.3-3c0-1.1,0.4-2.1,1.3-2.8c0.8-0.8,1.8-1.1,3-1.1 c0.9,0,1.6,0.2,2.3,0.7c0.7,0.5,1.2,1.1,1.6,2c0.4,0.9,0.6,2,0.6,3.3c0,1.8-0.4,3.4-1.1,5c-0.7,1.5-1.7,2.8-2.7,3.7 c-1.1,0.9-2.1,1.3-2.9,1.3c-0.6,0-1-0.2-1.3-0.5c-0.3-0.4-0.5-0.8-0.5-1.3c0-0.7,0.4-1.3,1.1-1.8 C1164.7,530.4,1165.7,529,1165.7,527.2z M1162.1,501.5c0-1.3,0.4-2.2,1.2-2.9c0.8-0.7,1.8-1,2.9-1c1.1,0,2,0.4,2.8,1.1 c0.8,0.7,1.2,1.7,1.2,2.9c0,1-0.4,1.9-1.2,2.8c-0.8,0.8-1.7,1.2-2.7,1.2c-0.7,0-1.4-0.2-2-0.5c-0.6-0.4-1.1-0.8-1.5-1.4 C1162.2,502.9,1162.1,502.2,1162.1,501.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1200,512.3c-1-0.6-1.7-1.2-2.4-1.9c-0.6-0.7-1.1-1.5-1.5-2.4c-0.4-0.9-0.7-2.1-0.8-3.4 c-0.2-1.3-0.2-2.8-0.2-4.6c0-1.7,0-3-0.1-3.9c-0.1-0.9-0.2-1.6-0.4-2c-0.2-0.4-0.5-0.7-0.9-0.8c-0.4-0.2-1-0.3-1.8-0.4 c-0.7-0.1-1.2-0.4-1.7-1c-0.5-0.6-0.7-1.3-0.7-2.3c0-2.1,1.3-3.2,3.9-3.2c1.7,0,3.1,0.3,4.4,1c1.3,0.7,2.2,1.6,3,2.9 c0.7,1.2,1.1,2.7,1.1,4.2c0.1,5.9,0.2,9.2,0.4,9.8c0.3,1.2,0.7,2.1,1.3,2.7c0.6,0.6,1.2,1.2,2,1.6c0.8,0.5,1.4,0.9,1.8,1.4 c0.4,0.5,0.6,1.2,0.6,2.1c0,1.3-0.5,2.3-1.5,2.9c-1.2,0.8-2.2,1.4-2.7,2c-0.6,0.6-1,1.3-1.2,2.2c-0.2,0.9-0.4,2.2-0.4,3.9 c0,1.7-0.1,3.9-0.1,6.5c-0.1,2.5-0.8,4.4-2.4,5.9c-1.5,1.5-3.6,2.2-6.1,2.2c-1.2,0-2.2-0.3-2.9-0.8c-0.7-0.6-1-1.4-1-2.4 c0-0.6,0.1-1.1,0.3-1.6c0.2-0.5,0.5-0.9,0.8-1.1c0.3-0.3,0.7-0.4,1.2-0.5c0.8-0.1,1.4-0.2,1.8-0.4c0.4-0.2,0.7-0.5,0.9-0.9 c0.2-0.4,0.3-1.1,0.4-2c0.1-0.9,0.1-2.1,0.1-3.8c0-2.5,0.2-4.4,0.4-5.8c0.2-1.4,0.7-2.6,1.4-3.6 C1197.6,514.1,1198.6,513.2,1200,512.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M157.3,1057.6c-17.6,0-31.9-14.3-31.9-31.9V693.6c0-17.6,14.3-31.9,31.9-31.9H682 c17.6,0,31.9,14.3,31.9,31.9v332.1c0,17.6-14.3,31.9-31.9,31.9H157.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_20_",
    d: "M695.3,1025.7c0,7.3-5.9,13.3-13.3,13.3H157.3c-7.3,0-13.3-5.9-13.3-13.3V693.6 c0-7.3,5.9-13.3,13.3-13.3H682c7.3,0,13.3,5.9,13.3,13.3V1025.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_21_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_20_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.3005,
    y1: 856.8804,
    x2: 752.7819,
    y2: 856.8804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1047,
    style: {
      stopColor: "#FC6F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9543,
    style: {
      stopColor: "#F7426E"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3,
    y: 621.7,
    className: "st36",
    width: 683.5,
    height: 470.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 110.8,
    y: 656.4,
    className: "st37",
    width: 619.1,
    height: 47.8
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st38"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st39",
    cx: 427.9,
    cy: 863.2,
    r: 122.7
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -144.2759,
    y1: 998.6476,
    x2: 724.1763,
    y2: 1117.2657
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A7AB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M755.2,1091.9c0,3.3-2.6,5.9-5.9,5.9H90c-3.3,0-5.9-2.6-5.9-5.9v-32.5c0-3.3,2.6-5.9,5.9-5.9h659.3 c3.3,0,5.9,2.6,5.9,5.9V1091.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.7189,
    y1: 1102.515,
    x2: 422.322,
    y2: 998.9536
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A7AB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M351.9,1053.7c-0.6,1.5-1,3.2-1,4.9v0.9c0,7.1,5.8,12.9,12.9,12.9h111.7c7.1,0,12.9-5.8,12.9-12.9v-0.9 c0-1.8-0.4-3.4-1-4.9H351.9z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M450.3,848.6l-3.9-14l-11.2,3.1c-2.2-4.4-5.3-8.3-8.9-11.4l5.7-10.1l-12.6-7.2l-5.7,10.1 c-4.5-1.5-9.4-2.1-14.3-1.8l-3.1-11.2l-14,3.9l3.1,11.2c-4.4,2.2-8.3,5.3-11.4,8.9l-10.1-5.7l-7.1,12.6l10.1,5.7 c-1.5,4.5-2.1,9.4-1.8,14.3l-11.2,3.1l3.9,14L369,871c2.2,4.4,5.3,8.3,8.9,11.4l-5.7,10.1l12.6,7.2l5.7-10.1 c4.5,1.5,9.4,2.1,14.3,1.8l3.1,11.2l14-3.9l-3.1-11.2c4.4-2.2,8.3-5.3,11.4-8.9l10.1,5.7l7.1-12.6l-10.1-5.7 c1.5-4.5,2.1-9.4,1.8-14.3L450.3,848.6z M407.6,874.2c-10.9,3-22.3-3.4-25.3-14.3c-3-10.9,3.4-22.3,14.3-25.3 c10.9-3,22.3,3.4,25.3,14.3C425,859.8,418.5,871.2,407.6,874.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M411,851.9c1.4,4.9-1.5,10-6.4,11.4c-4.9,1.4-10-1.5-11.4-6.4c-1.4-4.9,1.5-10,6.4-11.4 C404.6,844.1,409.7,847,411,851.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M477.6,801l-1.8-6.7l-5.3,1.5c-1.1-2.1-2.5-3.9-4.2-5.4l2.7-4.8l-6-3.4l-2.7,4.8c-2.2-0.7-4.5-1-6.8-0.8 l-1.5-5.3l-6.7,1.8l1.5,5.3c-2.1,1.1-3.9,2.5-5.4,4.2l-4.8-2.7l-3.4,6l4.8,2.7c-0.7,2.2-1,4.5-0.8,6.8l-5.3,1.5l1.8,6.7l5.3-1.5 c1.1,2.1,2.5,3.9,4.2,5.4l-2.7,4.8l6,3.4l2.7-4.8c2.2,0.7,4.5,1,6.8,0.8l1.5,5.3l6.7-1.8l-1.5-5.3c2.1-1.1,3.9-2.5,5.4-4.2 l4.8,2.7l3.4-6l-4.8-2.7c0.7-2.2,1-4.5,0.8-6.8L477.6,801z M457.2,813.3c-5.2,1.4-10.6-1.6-12.1-6.8c-1.4-5.2,1.6-10.6,6.8-12.1 c5.2-1.4,10.6,1.6,12.1,6.8C465.5,806.4,462.4,811.8,457.2,813.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M501.8,842l-1.8-6.7l-5.3,1.5c-1.1-2.1-2.5-3.9-4.2-5.4l2.7-4.8l-6-3.4l-2.7,4.8c-2.2-0.7-4.5-1-6.8-0.8 l-1.5-5.3l-6.7,1.8l1.5,5.3c-2.1,1.1-3.9,2.5-5.4,4.2l-4.8-2.7l-3.4,6l4.8,2.7c-0.7,2.2-1,4.5-0.8,6.8l-5.3,1.5l1.8,6.7l5.3-1.5 c1.1,2.1,2.5,3.9,4.2,5.4l-2.7,4.8l6,3.4l2.7-4.8c2.2,0.7,4.5,1,6.8,0.8l1.5,5.3l6.7-1.8l-1.5-5.3c2.1-1.1,3.9-2.5,5.4-4.2 l4.8,2.7l3.4-6l-4.8-2.7c0.7-2.2,1-4.5,0.8-6.8L501.8,842z M481.5,854.2c-5.2,1.4-10.6-1.6-12.1-6.8c-1.4-5.2,1.6-10.6,6.8-12.1 c5.2-1.4,10.6,1.6,12.1,6.8C489.8,847.3,486.7,852.7,481.5,854.2z"
  })))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M600.4,948.3c0,3.6-2.9,6.4-6.4,6.4H270.8c-3.6,0-6.4-2.9-6.4-6.4l0,0c0-3.6,2.9-6.4,6.4-6.4h323.1 C597.5,941.8,600.4,944.7,600.4,948.3L600.4,948.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M600,953.4c0,3.6-2.9,6.4-6.4,6.4H270.4c-3.6,0-6.4-2.9-6.4-6.4l0,0c0-3.6,2.9-6.4,6.4-6.4h323.1 C597.1,947,600,949.8,600,953.4L600,953.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M600.4,948.3c0,3.6-2.9,6.4-6.4,6.4H270.8c-3.6,0-6.4-2.9-6.4-6.4l0,0c0-3.6,2.9-6.4,6.4-6.4h323.1 C597.5,941.8,600.4,944.7,600.4,948.3L600.4,948.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.0934,
    y1: 943.3121,
    x2: 618.6703,
    y2: 943.3121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1047,
    style: {
      stopColor: "#FC6F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9543,
    style: {
      stopColor: "#F7426E"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M272.3,970.4h-14.2l24.1-54.1h14.2L272.3,970.4z M323.2,916.2h-14.2L285,970.4h14.2L323.2,916.2z  M350.1,916.2h-14.2l-24.1,54.1H326L350.1,916.2z M377,916.2h-14.2l-24.1,54.1h14.2L377,916.2z M403.8,916.2h-14.2l-24.1,54.1h14.2 L403.8,916.2z M430.7,916.2h-14.2l-24.1,54.1h14.2L430.7,916.2z M457.5,916.2h-14.2l-24.1,54.1h14.2L457.5,916.2z M484.4,916.2 h-14.2l-24.1,54.1h14.2L484.4,916.2z M511.2,916.2h-14.2L473,970.4h14.2L511.2,916.2z M538.1,916.2h-14.2l-24.1,54.1H514 L538.1,916.2z M565,916.2h-14.2l-24.1,54.1h14.2L565,916.2z M591.8,916.2h-14.2l-24.1,54.1h14.2L591.8,916.2z M618.7,916.2h-14.2 l-24.1,54.1h14.2L618.7,916.2z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1914.3,574.6c0-7.1-5.8-12.9-12.9-12.9h-299.1c-7.1,0-12.9,5.8-12.9,12.9v54.8h324.9V574.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1589.4,629.4v342.9c0,7.1,5.8,12.9,12.9,12.9h299.1c7.1,0,12.9-5.8,12.9-12.9V629.4H1589.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 1606.0885,
    y1: 564.4257,
    x2: 1930.9406,
    y2: 564.4257
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A7AB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M1930.9,543.5c0-7.1-5.8-12.9-12.9-12.9H1619c-7.1,0-12.9,5.8-12.9,12.9v54.8h324.9V543.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1606.1,598.3v342.9c0,7.1,5.8,12.9,12.9,12.9H1918c7.1,0,12.9-5.8,12.9-12.9V598.3H1606.1z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1820.5,655c0,3.2-2.6,5.8-5.8,5.8h-83.1c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h83.1 C1817.9,649.2,1820.5,651.8,1820.5,655L1820.5,655z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1869.7,655.4c0,3.2-2.6,5.8-5.8,5.8h-29.2c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.2 C1867.2,649.6,1869.7,652.2,1869.7,655.4L1869.7,655.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1778.9,676.4c0,3.2-2.6,5.8-5.8,5.8h-29.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1776.3,670.6,1778.9,673.2,1778.9,676.4L1778.9,676.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1879.5,698.5c0,3.2-2.6,5.8-5.8,5.8h-29.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1876.9,692.7,1879.5,695.3,1879.5,698.5L1879.5,698.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M1885.1,676.9c0,3.2-2.6,5.8-5.8,5.8h-83.1c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h83.1 C1882.6,671.1,1885.1,673.7,1885.1,676.9L1885.1,676.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1835.4,740c0,3.2-2.6,5.8-5.8,5.8h-44.6c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h44.6 C1832.8,734.3,1835.4,736.8,1835.4,740L1835.4,740z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1828.6,697.7c0,3.2-2.6,5.8-5.8,5.8h-83.1c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h83.1 C1826,691.9,1828.6,694.5,1828.6,697.7L1828.6,697.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1818.3,892.9c0,3.2-2.6,5.8-5.8,5.8h-83.1c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h83.1 C1815.8,887.1,1818.3,889.7,1818.3,892.9L1818.3,892.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1873.7,717.2c0,3.2-2.6,5.8-5.8,5.8h-83.1c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h83.1 C1871.1,711.4,1873.7,714,1873.7,717.2L1873.7,717.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1843.3,782.6c0,3.2-2.6,5.8-5.8,5.8h-52.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h52.3 C1840.7,776.9,1843.3,779.4,1843.3,782.6L1843.3,782.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1874.5,760.7c0,3.2-2.6,5.8-5.8,5.8h-83.1c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h83.1 C1871.9,754.9,1874.5,757.5,1874.5,760.7L1874.5,760.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1712.2,650.2c0,3.2-2.6,5.8-5.8,5.8h-29.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1709.6,644.4,1712.2,647,1712.2,650.2L1712.2,650.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1667,650.7c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C1664.2,644.5,1667,647.3,1667,650.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1712.2,672.1c0,3.2-2.6,5.8-5.8,5.8h-29.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1709.6,666.3,1712.2,668.9,1712.2,672.1L1712.2,672.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1667,672.5c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C1664.2,666.4,1667,669.1,1667,672.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1712.2,693.9c0,3.2-2.6,5.8-5.8,5.8h-29.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1709.6,688.2,1712.2,690.8,1712.2,693.9L1712.2,693.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1667,694.4c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C1664.2,688.2,1667,691,1667,694.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1766.1,715.8c0,3.2-2.6,5.8-5.8,5.8H1731c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1763.5,710,1766.1,712.6,1766.1,715.8L1766.1,715.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1720.9,716.3c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2S1720.9,712.8,1720.9,716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1766.1,737.7c0,3.2-2.6,5.8-5.8,5.8H1731c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1763.5,731.9,1766.1,734.5,1766.1,737.7L1766.1,737.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1720.9,738.1c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2S1720.9,734.7,1720.9,738.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1898.5,740c0,3.2-2.6,5.8-5.8,5.8h-29.2c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.2 C1895.9,734.2,1898.5,736.8,1898.5,740L1898.5,740z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1853.3,740.4c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C1850.5,734.3,1853.3,737,1853.3,740.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1779.2,827c0,3.2-2.6,5.8-5.8,5.8h-44.6c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h44.6 C1776.6,821.3,1779.2,823.8,1779.2,827L1779.2,827z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M1817.5,804.2c0,3.2-2.6,5.8-5.8,5.8h-83.1c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h83.1 C1814.9,798.4,1817.5,801,1817.5,804.2L1817.5,804.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1787.1,869.6c0,3.2-2.6,5.8-5.8,5.8H1729c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h52.3 C1784.5,863.9,1787.1,866.4,1787.1,869.6L1787.1,869.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M1818.3,847.7c0,3.2-2.6,5.8-5.8,5.8h-83.1c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h83.1 C1815.7,841.9,1818.3,844.5,1818.3,847.7L1818.3,847.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1842.3,827c0,3.2-2.6,5.8-5.8,5.8h-29.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1839.7,821.2,1842.3,823.8,1842.3,827L1842.3,827z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1797.1,827.4c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C1794.3,821.3,1797.1,824,1797.1,827.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1881.9,846.2c0,3.2-2.6,5.8-5.8,5.8h-29.2c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.2 C1879.3,840.4,1881.9,843,1881.9,846.2L1881.9,846.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1836.7,846.7c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C1834,840.5,1836.7,843.3,1836.7,846.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1766.1,759.5c0,3.2-2.6,5.8-5.8,5.8H1731c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1763.5,753.8,1766.1,756.4,1766.1,759.5L1766.1,759.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1720.9,760c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2S1720.9,756.6,1720.9,760z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1766.1,781.4c0,3.2-2.6,5.8-5.8,5.8H1731c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1763.5,775.6,1766.1,778.2,1766.1,781.4L1766.1,781.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1720.9,781.8c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2S1720.9,778.4,1720.9,781.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1712.2,803.3c0,3.2-2.6,5.8-5.8,5.8h-29.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1709.6,797.5,1712.2,800.1,1712.2,803.3L1712.2,803.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1660.8,
    cy: 803.7,
    r: 6.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1712.2,825.1c0,3.2-2.6,5.8-5.8,5.8h-29.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1709.6,819.4,1712.2,821.9,1712.2,825.1L1712.2,825.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1667,825.6c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C1664.2,819.4,1667,822.2,1667,825.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1712.2,847c0,3.2-2.6,5.8-5.8,5.8h-29.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1709.6,841.2,1712.2,843.8,1712.2,847L1712.2,847z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1667,847.4c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2C1664.2,841.3,1667,844,1667,847.4 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1712.2,868.9c0,3.2-2.6,5.8-5.8,5.8h-29.3c-3.2,0-5.8-2.6-5.8-5.8l0,0c0-3.2,2.6-5.8,5.8-5.8h29.3 C1709.6,863.1,1712.2,865.7,1712.2,868.9L1712.2,868.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1667,869.3c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C1664.2,863.1,1667,865.9,1667,869.3z"
  })))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1908.3,560.4c0,6.2-5.1,11.3-11.3,11.3c-6.2,0-11.3-5.1-11.3-11.3c0-6.2,5.1-11.3,11.3-11.3 C1903.3,549.2,1908.3,554.2,1908.3,560.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 1581.3961,
    y1: 938.4535,
    x2: 1672.1561,
    y2: 938.4535
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A7AB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M1583.4,1015.1c0,0-5.5-92.2,1.5-106.7c6.9-14.6,17.1-23.6,27.1-12.7c10,10.9,14.1,12.6,14.3-0.5 c0.2-13.1,17.1-41.7,35.7-31c18.6,10.7,4.9,29-0.6,36.8c-5.5,7.8-13.7,18.4-5.6,16.5c8.1-1.9,17.3-4.7,16.3,3.5 c-1,8.2-20.4,13-30.1,21.1c-9.7,8.2-10.4,14.9-1.5,13.5c9-1.4,23,8.6,13.7,15.9c-9.2,7.3-58.2,39.6-58.2,39.6L1583.4,1015.1z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1589.7,1008c0.4-1.7,1-3.7,1.7-6.1c0.6-2.4,1.6-4.9,2.5-7.8c0.9-2.9,2.1-5.9,3.4-9.1 c1.2-3.2,2.6-6.5,4.1-10c0.1-0.3,0.3-0.7,0.4-1c-0.4-1.2-0.9-3-1.5-5.1c-0.6-2.1-1.1-4.5-1.7-7.1c-0.3-1.3-0.6-2.6-0.8-4 c-0.3-1.4-0.5-2.8-0.8-4.2c-0.2-1.4-0.5-2.8-0.7-4.2c-0.2-1.4-0.4-2.7-0.6-4.1c-0.4-2.6-0.7-5.1-0.9-7.2 c-0.4-4.2-0.5-7.1-0.5-7.1s1,2.7,2,6.9c0.6,2.1,1.1,4.5,1.7,7.1c0.3,1.3,0.6,2.6,0.8,4c0.3,1.4,0.5,2.8,0.8,4.2 c0.2,1.4,0.5,2.8,0.7,4.2c0.2,1.4,0.4,2.7,0.6,4.1c0.4,2.6,0.7,5.1,0.9,7.2c0.2,1.7,0.3,3.2,0.4,4.4c1.2-2.8,2.5-5.7,3.7-8.5 c1.6-3.6,3.3-7.2,5-10.8c3.5-7.2,6.9-14.3,10.4-21c3.4-6.6,6.7-12.8,9.6-18c2.9-5.2,5.4-9.5,7.1-12.6c1.7-3,2.8-4.7,2.8-4.7 s-0.8,1.8-2.3,5c-1.5,3.1-3.6,7.6-6.2,13c-3.8,7.9-8.5,17.8-13.5,28.2c0.1-0.1,0.2-0.2,0.3-0.3c1.1-1.1,2.4-2.4,3.8-3.7 c1.4-1.3,3-2.7,4.6-4c1.6-1.3,3.3-2.6,4.8-3.7c1.6-1.2,3.1-2.2,4.4-3c2.6-1.7,4.5-2.7,4.5-2.7s-1.3,1.7-3.5,3.9 c-1.1,1.1-2.4,2.4-3.9,3.7c-1.4,1.3-3,2.7-4.6,4c-1.6,1.3-3.3,2.6-4.8,3.7c-1.6,1.2-3.1,2.2-4.4,3c-0.9,0.6-1.8,1.1-2.4,1.5 c-1.4,2.9-2.8,5.8-4.2,8.8c-1.7,3.6-3.4,7.2-5,10.7c-1.6,3.6-3.2,7-4.8,10.4c-1.5,3.4-3.1,6.7-4.4,9.8c-1.3,3.1-2.7,6.1-3.8,8.8 c-0.6,1.4-1.1,2.7-1.6,4c-0.5,1.2-1,2.4-1.4,3.6c-0.8,2.3-1.6,4.2-2.1,5.9c-1,3.3-1.6,5.2-1.6,5.2S1589,1011.5,1589.7,1008z"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1624.7,976.5c0,0-1.6,1.3-4.1,2.8c-1.3,0.8-2.7,1.7-4.4,2.5c-1.6,0.9-3.4,1.8-5.1,2.6 c-1.8,0.8-3.6,1.6-5.3,2.3c-1.7,0.7-3.3,1.3-4.7,1.8c-2.8,1-4.8,1.4-4.8,1.4s1.6-1.3,4.1-2.8c1.3-0.8,2.7-1.7,4.4-2.5 c1.6-0.9,3.4-1.8,5.1-2.6c1.8-0.8,3.6-1.6,5.3-2.3c1.7-0.7,3.3-1.3,4.7-1.8C1622.8,976.9,1624.7,976.5,1624.7,976.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 1471.6517,
    y1: 878.3453,
    x2: 1618.1876,
    y2: 878.3453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A7AB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M1580.5,1015.8c0,0,42.9-147.3,37.1-173.5c-5.8-26.2-18.9-44.5-39.1-30.5c-20.2,14-27.6,15.3-23-6.1 c4.6-21.3-12.3-73.8-46.4-63.3c-34.1,10.5-18.6,45.2-12.6,59.8c6,14.6,15.4,34.8,3,28.8c-12.4-6-26.3-14-27.7-0.3 c-1.4,13.7,28.3,28.6,41,45.4c12.7,16.8,11.4,28-2.6,22.4c-14-5.6-40.4,5.4-28.1,20.6c12.3,15.2,79.7,85.7,79.7,85.7 L1580.5,1015.8z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M1562.4,945.3c-1.3-6-2.6-12.3-3.9-18.7c-1.4-6.3-2.8-12.8-4.2-19.2c-1.2-5.3-2.4-10.5-3.5-15.7 c-1-0.9-2.1-2-3.4-3.4c-1.8-1.9-3.9-4.1-6-6.5c-2.1-2.4-4.3-5.1-6.4-7.8c-2.1-2.7-4.2-5.5-6-8.2c-1.9-2.6-3.5-5.2-4.9-7.4 c-2.7-4.4-4.3-7.6-4.3-7.6s2.7,2.2,6.3,6c1.8,1.9,3.9,4.1,6,6.5c2.1,2.4,4.3,5.1,6.5,7.8c2.1,2.7,4.2,5.5,6,8.1 c1.9,2.6,3.5,5.2,4.9,7.4c0.1,0.2,0.2,0.4,0.3,0.6c-4.2-18.7-8.2-36.4-11.4-50.7c-2.1-9.7-3.9-17.8-5.2-23.4 c-1.2-5.7-1.9-8.9-1.9-8.9s1.1,3.1,2.8,8.7c1.7,5.6,4.2,13.4,6.8,23c2.7,9.5,5.8,20.7,8.8,32.7c3.1,12,6.1,24.9,9.1,37.8 c1.4,6.5,2.7,13,4.1,19.3c1,5.2,2,10.2,2.9,15.2c0.5-1.9,1.3-4.2,2.2-6.9c1.1-3.4,2.5-7.3,4.1-11.4c0.8-2.1,1.6-4.2,2.5-6.4 c0.9-2.2,1.8-4.3,2.7-6.5c0.9-2.2,1.9-4.3,2.8-6.5c0.9-2.1,1.9-4.2,2.8-6.2c1.9-4,3.7-7.7,5.4-10.8c3.3-6.3,5.8-10.4,5.8-10.4 s-1.1,4.6-3.4,11.4c-1.1,3.4-2.5,7.3-4.1,11.4c-0.8,2-1.6,4.2-2.5,6.3c-0.9,2.1-1.8,4.3-2.7,6.5c-0.9,2.2-1.9,4.3-2.8,6.4 c-0.9,2.1-1.9,4.2-2.8,6.2c-1.9,4-3.7,7.7-5.4,10.9c-1.7,3.3-3.2,5.9-4.3,7.8c0.1,0.6,0.2,1.2,0.3,1.7c1,6.1,2.1,12,2.9,17.7 c0.8,5.6,1.6,11,2.1,15.9c0.5,5,1.1,9.5,1.2,13.5c0.2,4,0.5,7.5,0.4,10.5c-0.1,5.8-0.3,9.1-0.3,9.1s-0.3-3.3-0.6-9.1 c-0.2-2.9-0.8-6.3-1.2-10.3c-0.2-2-0.5-4.1-1-6.3c-0.4-2.2-0.8-4.6-1.2-7c-0.4-2.9-1-5.9-1.6-9c-1.3-0.7-3.2-1.7-5.4-3.1 c-2.1-1.3-4.5-2.9-7-4.6c-2.5-1.8-5.1-3.7-7.7-5.7c-2.6-2-5.1-4.1-7.4-6.2c-2.3-2-4.4-4-6.1-5.7c-3.5-3.5-5.6-6.1-5.6-6.1 s3,1.4,7.2,4c2.1,1.3,4.5,2.9,7,4.6c2.5,1.8,5.1,3.7,7.7,5.7c2.6,2,5.1,4.1,7.4,6.2c2.3,2,4.4,4,6.1,5.7c1.4,1.4,2.6,2.7,3.5,3.7 c-0.3-1.7-0.7-3.4-1-5.2C1564.9,957.2,1563.6,951.4,1562.4,945.3z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1556.3,997.5 1615.2,997.5 1629.6,997.5 1620.5,1077.1 1615.2,1077.1 1556.3,1077.1 1551,1077.1  1541.9,997.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1536,
    y: 995.7,
    className: "st34",
    width: 101.2,
    height: 16.2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.4101,
    y1: 662.7019,
    x2: 234.5308,
    y2: 662.7019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1047,
    style: {
      stopColor: "#0A0245"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9543,
    style: {
      stopColor: "#300030"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st48",
    cx: 158.5,
    cy: 662.7,
    r: 76.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.2281,
    y1: 662.7017,
    x2: 201.7128,
    y2: 662.7017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1047,
    style: {
      stopColor: "#FC6F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9543,
    style: {
      stopColor: "#F7426E"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M201.7,662.7c0-23.8-19.4-43.2-43.2-43.2s-43.2,19.4-43.2,43.2c0,11.9,4.9,23.3,13.6,31.5l0,0.1l1.2,1 c0,0,0,0,0,0l5,4.4l0-0.6c6.9,4.5,15,6.9,23.4,6.9c8.3,0,16.4-2.4,23.4-6.9l0,0.6l5-4.4c0,0,0,0,0,0l1.2-1l0-0.1 C196.8,686,201.7,674.6,201.7,662.7z M121.8,662.7c0-20.2,16.5-36.7,36.7-36.7c20.2,0,36.7,16.5,36.7,36.7c0,8.5-3,16.7-8.3,23.3 c0,0,0,0,0-0.1c-0.1-0.5-0.3-1-0.5-1.5c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.4-0.3-0.7-0.4-1.1c-0.1-0.2-0.1-0.3-0.2-0.5 c-0.1-0.3-0.3-0.6-0.4-1c-0.1-0.2-0.1-0.3-0.2-0.5c-0.2-0.4-0.4-0.7-0.6-1.1c0-0.1-0.1-0.2-0.1-0.3c-0.3-0.4-0.5-0.9-0.8-1.3 c-0.1-0.1-0.2-0.2-0.2-0.4c-0.2-0.3-0.4-0.6-0.6-0.9c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.3-0.4-0.6-0.7-0.8c-0.1-0.1-0.2-0.3-0.3-0.4 c-0.3-0.4-0.6-0.7-0.9-1c0,0-0.1-0.1-0.1-0.1c-0.3-0.4-0.7-0.7-1.1-1.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.3-0.5-0.5-0.8-0.7 c-0.1-0.1-0.3-0.2-0.4-0.3c-0.3-0.2-0.6-0.5-0.8-0.7c-0.1-0.1-0.2-0.2-0.4-0.3c-0.4-0.3-0.8-0.6-1.2-0.9c0,0,0,0,0,0 c-0.4-0.3-0.8-0.5-1.2-0.8c-0.1-0.1-0.3-0.2-0.4-0.2c-0.3-0.2-0.6-0.4-0.9-0.5c-0.2-0.1-0.3-0.2-0.5-0.2c-0.3-0.2-0.7-0.3-1-0.5 c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.2-0.9-0.4-1.4-0.6c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.2c0.2-0.2,0.3-0.4,0.5-0.6 c0.1-0.1,0.2-0.3,0.4-0.4c0.2-0.2,0.3-0.4,0.5-0.6c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.2,0.3-0.5,0.4-0.7c0.1-0.2,0.2-0.3,0.3-0.5 c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.2,0.2-0.3,0.2-0.5c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.3,0.1-0.6,0.2-0.8 c0-0.2,0.1-0.3,0.1-0.5c0.1-0.3,0.1-0.6,0.1-0.9c0-0.2,0.1-0.3,0.1-0.5c0-0.5,0.1-0.9,0.1-1.4c0-8.2-6.7-14.9-14.9-14.9 c-8.2,0-14.9,6.7-14.9,14.9c0,0.5,0,1,0.1,1.4c0,0.2,0,0.3,0.1,0.5c0,0.3,0.1,0.6,0.1,0.9c0,0.2,0.1,0.4,0.1,0.5 c0.1,0.3,0.1,0.5,0.2,0.8c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.3,0.2,0.5,0.3,0.7c0.1,0.2,0.2,0.4,0.2,0.5c0.1,0.2,0.2,0.5,0.3,0.7 c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.2,0.4,0.4,0.7c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.3,0.3,0.4,0.5 c0.2,0.2,0.3,0.4,0.5,0.6c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0c-0.5,0.2-1,0.4-1.4,0.6c-0.1,0.1-0.3,0.1-0.4,0.2 c-0.3,0.2-0.7,0.3-1,0.5c-0.2,0.1-0.3,0.2-0.5,0.2c-0.3,0.2-0.6,0.3-0.9,0.5c-0.1,0.1-0.3,0.2-0.4,0.2c-0.4,0.3-0.9,0.5-1.3,0.8 c0,0,0,0,0,0c-0.4,0.3-0.8,0.6-1.2,0.9c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.2-0.6,0.5-0.9,0.7c-0.1,0.1-0.2,0.2-0.4,0.3 c-0.3,0.2-0.6,0.5-0.8,0.8c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.4-0.7,0.7-1.1,1.1c0,0,0,0,0,0.1c-0.3,0.4-0.6,0.7-1,1.1 c-0.1,0.1-0.2,0.2-0.3,0.4c-0.2,0.3-0.5,0.6-0.7,0.9c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.1-0.2,0.2-0.2,0.3 c-0.3,0.4-0.5,0.9-0.8,1.3c0,0.1-0.1,0.2-0.1,0.2c-0.2,0.4-0.4,0.7-0.6,1.1c-0.1,0.2-0.2,0.3-0.2,0.5c-0.2,0.3-0.3,0.6-0.4,1 c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.3-0.3,0.7-0.4,1.1c-0.1,0.1-0.1,0.3-0.2,0.4c-0.2,0.5-0.3,1-0.5,1.5c0,0,0,0.1,0,0.1 C124.8,679.4,121.8,671.2,121.8,662.7z M166.7,657.4c0,0.1,0,0.2,0,0.2c0,0.2,0,0.3-0.1,0.5c0,0.1,0,0.2-0.1,0.3 c0,0.2-0.1,0.3-0.1,0.5c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.3-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.3-0.2,0.4 c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.3-0.2,0.4c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.4c-0.1,0.1-0.1,0.2-0.2,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.3,0.1-0.4,0.1 c-0.1,0-0.2,0-0.4,0.1c-0.1,0-0.2,0-0.3,0l-0.1,0c-0.4,0-0.7,0-1.1,0c-0.4,0-0.7,0-1.1,0l-0.1,0c-0.1,0-0.2,0-0.3-0.1 c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.1 c-0.1-0.1-0.2-0.1-0.4-0.2c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.1-0.4-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.2-0.2-0.2 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.4 c-0.1-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.1-0.3-0.2-0.4c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1-0.1-0.2-0.1-0.3 c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2-0.1-0.3c0-0.2-0.1-0.3-0.1-0.5c0-0.1,0-0.2,0-0.2c0-0.3,0-0.5,0-0.8c0-4.6,3.7-8.3,8.3-8.3 c4.6,0,8.3,3.7,8.3,8.3C166.8,656.9,166.8,657.1,166.7,657.4z M135.6,691.4c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.6,0.2-1 c0.1-0.4,0.1-0.7,0.2-1.1c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.4,0.2-0.7,0.3-1c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.3-0.7,0.4-1 c0.1-0.3,0.3-0.6,0.4-0.9c0.2-0.3,0.3-0.6,0.5-1c0.2-0.3,0.3-0.6,0.5-0.8c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.5,0.5-0.8 c0.2-0.3,0.4-0.6,0.7-0.9c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.4-0.4,0.6-0.7c0.3-0.3,0.5-0.5,0.8-0.7 c0.2-0.2,0.5-0.4,0.7-0.6c0.3-0.2,0.6-0.5,0.9-0.7c0.2-0.2,0.5-0.4,0.7-0.5c0.3-0.2,0.6-0.4,1-0.6c0.3-0.2,0.5-0.3,0.8-0.5 c0.3-0.2,0.7-0.4,1.1-0.5c0.3-0.1,0.5-0.3,0.8-0.4c0.4-0.2,0.8-0.3,1.2-0.5c0.2-0.1,0.5-0.2,0.7-0.3c0.6-0.2,1.3-0.4,2-0.6 c0.1,0,0.2,0,0.4-0.1c0.6-0.1,1.1-0.2,1.7-0.3c0.3,0,0.5-0.1,0.8-0.1c0.4,0,0.8-0.1,1.3-0.1c0,0,0,0,0.1,0c0.4,0,0.8,0.1,1.3,0.1 s0.9,0,1.3-0.1c0,0,0,0,0.1,0c0.4,0,0.8,0.1,1.3,0.1c0.3,0,0.5,0,0.8,0.1c0.6,0.1,1.1,0.2,1.7,0.3c0.1,0,0.3,0.1,0.4,0.1 c0.7,0.2,1.3,0.3,1.9,0.6c0.2,0.1,0.5,0.2,0.7,0.3c0.4,0.2,0.8,0.3,1.2,0.5c0.3,0.1,0.5,0.3,0.8,0.4c0.3,0.2,0.7,0.3,1,0.5 c0.3,0.1,0.5,0.3,0.8,0.5c0.3,0.2,0.6,0.4,0.9,0.6c0.3,0.2,0.5,0.4,0.8,0.5c0.3,0.2,0.6,0.4,0.9,0.7c0.2,0.2,0.5,0.4,0.7,0.6 c0.3,0.2,0.5,0.5,0.8,0.7c0.2,0.2,0.4,0.4,0.7,0.7c0.2,0.3,0.5,0.5,0.7,0.8c0.2,0.2,0.4,0.5,0.6,0.7c0.2,0.3,0.4,0.5,0.6,0.8 c0.2,0.3,0.4,0.5,0.6,0.8c0.2,0.3,0.4,0.6,0.6,0.9c0.2,0.3,0.3,0.6,0.5,0.8c0.2,0.3,0.3,0.6,0.5,0.9c0.1,0.3,0.3,0.6,0.4,0.9 c0.1,0.3,0.3,0.7,0.4,1c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.3,0.2,0.7,0.3,1c0.1,0.3,0.2,0.6,0.3,1c0.1,0.4,0.2,0.7,0.2,1.1 c0.1,0.3,0.1,0.6,0.2,1c0,0.1,0,0.2,0,0.3c-6.5,5.2-14.5,8-22.8,8C150.2,699.4,142.1,696.6,135.6,691.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 655.7753,
    y1: 843.1221,
    x2: 758.9106,
    y2: 843.1221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4A7AB7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9ECBE1"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M758.9,843.1c0,28.5-23.1,51.6-51.6,51.6c-28.5,0-51.6-23.1-51.6-51.6c0-28.5,23.1-51.6,51.6-51.6 C735.8,791.6,758.9,814.6,758.9,843.1z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0919 0 0 1 674.2915 857.9561)",
    className: "st5 st51 st52"
  }, "JS"))), /*#__PURE__*/React.createElement("g", null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1730.8,554.8c0,8.2-6.6,14.8-14.8,14.8h-259.8c-8.2,0-14.8-6.6-14.8-14.8V292c0-8.2,6.6-14.8,14.8-14.8h259.8 c8.2,0,14.8,6.6,14.8,14.8V554.8z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1714.7,538.1c0,8.2-6.6,14.8-14.8,14.8h-259.8c-8.2,0-14.8-6.6-14.8-14.8V275.4c0-8.2,6.6-14.8,14.8-14.8 h259.8c8.2,0,14.8,6.6,14.8,14.8V538.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 1469.6848,
    y1: 406.7154,
    x2: 1670.4199,
    y2: 406.7154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1047,
    style: {
      stopColor: "#FC6F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9543,
    style: {
      stopColor: "#F7426E"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M1570.1,507.1c-55.3,0-100.4-45-100.4-100.4c0-55.3,45-100.4,100.4-100.4c55.3,0,100.4,45,100.4,100.4 C1670.4,462.1,1625.4,507.1,1570.1,507.1z M1570.1,330.1c-42.2,0-76.6,34.4-76.6,76.6c0,42.2,34.4,76.6,76.6,76.6 c42.2,0,76.6-34.4,76.6-76.6C1646.6,364.5,1612.3,330.1,1570.1,330.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 1504.9036,
    y1: 406.5071,
    x2: 1639.9374,
    y2: 406.5071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1047,
    style: {
      stopColor: "#FC6F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9543,
    style: {
      stopColor: "#F7426E"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st54",
    x1: 1639.9,
    y1: 340.3,
    x2: 1504.9,
    y2: 472.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 1496.4329,
    y1: 406.5081,
    x2: 1648.4081,
    y2: 406.5081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1047,
    style: {
      stopColor: "#FC6F3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9543,
    style: {
      stopColor: "#F7426E"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "1513.4,481.1 1496.4,464.4 1631.5,331.9 1648.4,348.6  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramista);
export default __webpack_public_path__ + "static/media/programista.d1a1766eebca24d5c3aba6121cb90054.svg";
export { ForwardRef as ReactComponent };